import HeroSection from "./components/HeroSection";
import NavBar from "./components/NavBar";


function App() {
  return (
    <>
      <NavBar />
      <HeroSection />
    </>

  );
}

export default App;
